import { render } from "./EventManager.vue?vue&type=template&id=6576997e&scoped=true"
import script from "./EventManager.vue?vue&type=script&lang=js"
export * from "./EventManager.vue?vue&type=script&lang=js"

import "./EventManager.vue?vue&type=style&index=0&id=6576997e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6576997e"]])

export default __exports__